import { useClosePopup } from 'publisher/hooks/use-close-popup'
import useOptInSubmit from 'publisher/hooks/use-opt-in-submit-new'
import { usePage } from 'publisher/store'
import { getPageId } from 'publisher/store/page/pageSelectors'
import React from 'react'
import { SendFormBasePublisherButton } from 'src/publisher/entities/send-form-base-publisher-button'
import { SendFormActionButtonEntityInterface } from 'src/shared/entities/button/send-form.action-button.schema'

const TEST_ID = 'send-form-button'

export interface SendFormButtonProps {
  entity: SendFormActionButtonEntityInterface
}

const SendFormButton = ({ entity }: SendFormButtonProps) => {
  const pageId = usePage(getPageId)
  const closePopup = useClosePopup(entity, pageId)

  const [isLoading, errors, submit, isSuccess] = useOptInSubmit({
    optInButtonEntity: entity,
    closePopup,
  })

  return (
    <SendFormBasePublisherButton
      entityOrSubEntity={entity}
      isLoading={isLoading}
      errors={errors}
      onClick={submit}
      isSuccess={isSuccess}
      testId={TEST_ID}
    />
  )
}

export default SendFormButton
